<div class="container-fluid">
  <!-- HEADER -->
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">
          {{ isTransporterView ? "Transporter Vehicles" : "Manage Vehicle" }}
        </h1>

        <div>
          <button
            *ngIf="(isAdmin || isSuperSupervisor) && !isTransporterView"
            class="btn btn-sm me-2 gap-2 lr-btn"
            mat-raised-button
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            (click)="exportToExcel()"
          >
            Export
          </button>

          <button
            *ngIf="!isTransporterView"
            class="btn btn-dark btn-sm ms-2"
            mat-raised-button
            matTooltip="Add Vehicle"
            matTooltipPosition="left"
            routerLink="/superAdmin/manageVehicle/add-vehicle"
          >
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- CONTENT -->
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="filter-flex" *ngIf="!isTransporterView">
        <!-- SEARCH -->
        <div
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 d-flex align-items-center h-100"
        >
          <div class="form-group accountsinp mb-3 flex-fill">
            <label>Search</label>
            <input
              class="search-box form-control"
              placeholder="Search Vehicle, Driver, Transporter..."
              type="text"
              [(ngModel)]="searchText"
              (keyup)="applyFilter()"
            />
          </div>
        </div>

        <!-- DATE FILTERS -->
        <!-- <div class="col-lg-4 col-md-6 col-sm-12 col-12">
          <div class="d-flex gap-3 flex-wrap">
            <div class="form-group accountsinp mb-3 flex-fill">
              <label>From Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                (change)="onDateChange($event, 'from')"
              />
            </div>

            <div class="form-group accountsinp mb-3 flex-fill">
              <label>To Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                (change)="onDateChange($event, 'to')"
              />
            </div>
          </div>
        </div> -->

        <!-- CLEAR FILTER -->
        <div class="col-sm-2 d-flex align-items-center gap-2 h-100">
          <button
            class="clearFilterBtn"
            mat-raised-button
            (click)="clearFilters()"
          >
            <img src="/assets/images/svg/ClearFilter.svg" alt="clear" />
          </button>
        </div>
      </div>

      <!-- TABLE -->
      <div class="col-md-12 table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          matSortActive="vehicle_no"
          matSortDirection="desc"
          (matSortChange)="sortData($event)"
          class="row-border hover tablelist"
        >
          <!-- Vehicle Number -->
          <ng-container matColumnDef="vehicle_no">
            <th mat-header-cell *matHeaderCellDef>Vehicle Number</th>
            <td mat-cell *matCellDef="let user">{{ user.vehicle_no }}</td>
          </ng-container>

          <!-- Type -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Vehicle Type</th>
            <td mat-cell *matCellDef="let user">{{ user.type }}</td>
          </ng-container>

          <!-- Added By -->
          <ng-container matColumnDef="addedBy">
            <th mat-header-cell *matHeaderCellDef>Added By</th>
            <td mat-cell *matCellDef="let user">
              {{ user.createdBy?.full_name || "-" }}
            </td>
          </ng-container>

          <!-- Transporter -->
          <ng-container matColumnDef="transporterName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Transporter Name
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.transporter?.user_id?.full_name || "-" }}
            </td>
          </ng-container>

          <!-- Policy -->
          <ng-container matColumnDef="policyNumber">
            <th mat-header-cell *matHeaderCellDef>Policy Number</th>
            <td mat-cell *matCellDef="let user">{{ user.policyNumber }}</td>
          </ng-container>

          <!-- Road Tax -->
          <ng-container matColumnDef="roadTaxDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Road Tax Date
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.roadTaxDate | date: "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <!-- Insurance -->
          <ng-container matColumnDef="insuranceDueDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Insurance Due Date
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.insuranceDueDate | date: "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <!-- Fitness -->
          <ng-container matColumnDef="fitnessDueDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Fitness Due Date
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.fitnessDueDate | date: "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <!-- ACTION -->
          <ng-container matColumnDef="action" *ngIf="!isTransporterView">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Action
            </th>
            <td mat-cell *matCellDef="let user">
              <div class="d-flex justify-content-center gap-3">
                <button
                  [routerLink]="['/superAdmin/manageVehicle/view', user._id]"
                  class="btn p-0 shadow-none"
                >
                  <i matTooltip="View" class="fas fa-eye"></i>
                </button>

                <button
                  *ngIf="isAdmin || isSuperSupervisor"
                  [routerLink]="[
                    '/superAdmin/manageVehicle/edit-vehicle',
                    user._id,
                  ]"
                  class="btn p-0 shadow-none"
                >
                  <i matTooltip="Edit" class="fa-solid fa-pen-to-square"></i>
                </button>

                <button
                  *ngIf="isAdmin"
                  (click)="deleteuser(user._id)"
                  class="btn p-0 shadow-none"
                >
                  <i matTooltip="Delete" class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <!-- PAGINATOR -->
      <mat-paginator
        *ngIf="!isTransporterView"
        [length]="totalRecords"
        [pageSize]="limit"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>

<!-- SPINNER -->
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
